import { HttpMethod } from './backend.constants';

export abstract class HspBackendCall<I, O> {
    public abstract method: HttpMethod;
    public abstract endpoint: string;
    public contentType = 'application/json';
    public input?: I;
    public output?: O;

    public constructor(input: I) {
        this.input = input;
    }
}
